import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation({ onLogout }) {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="bg-white border-b border-slate-200 shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="font-display text-2xl font-black text-slate-900">Finance</h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <Link 
              to="/dashboard" 
              className={`font-medium transition-all ${
                isActive('/dashboard') 
                  ? 'text-slate-900 font-semibold border-b-2 border-amber-500 pb-1' 
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              Dashboard
            </Link>
            <Link 
              to="/transactions" 
              className={`font-medium transition-all ${
                isActive('/transactions') 
                  ? 'text-slate-900 font-semibold border-b-2 border-amber-500 pb-1' 
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              Transactions
            </Link>
            <Link 
              to="/profile" 
              className={`font-medium transition-all ${
                isActive('/profile') 
                  ? 'text-slate-900 font-semibold border-b-2 border-amber-500 pb-1' 
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              Profile
            </Link>
            <button
              onClick={onLogout}
              className="text-rose-600 hover:text-rose-700 font-medium transition-colors"
            >
              Logout
            </button>
          </div>

          {/* Mobile Hamburger Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-amber-500 transition-colors"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              {/* Hamburger Icon */}
              {!isMenuOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                /* Close Icon */
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out ${
          isMenuOpen 
            ? 'max-h-96 opacity-100' 
            : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-slate-200 shadow-lg">
          <Link
            to="/dashboard"
            onClick={handleLinkClick}
            className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
              isActive('/dashboard')
                ? 'bg-amber-50 text-amber-900 font-semibold'
                : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
            }`}
          >
            Dashboard
          </Link>
          <Link
            to="/transactions"
            onClick={handleLinkClick}
            className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
              isActive('/transactions')
                ? 'bg-amber-50 text-amber-900 font-semibold'
                : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
            }`}
          >
            Transactions
          </Link>
          <Link
            to="/profile"
            onClick={handleLinkClick}
            className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
              isActive('/profile')
                ? 'bg-amber-50 text-amber-900 font-semibold'
                : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
            }`}
          >
            Profile
          </Link>
          <button
            onClick={() => {
              handleLinkClick();
              onLogout();
            }}
            className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-rose-600 hover:bg-rose-50 hover:text-rose-700 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}